import { Slideshow } from '@mui/icons-material';
import { Box } from '@mui/material';

import { ComplianceTypes } from '@/constants';
import { bookmarkForLater, earnCpd, earnCpe } from '@/images';
import {
  ComplianceType,
  EpisodeCard as EpisodeCardType,
  Referrer,
} from '@/types';

import {
  EpisodeCard,
  EpisodeCardDimensions,
  EpisodeCardVariants,
} from '../../EpisodeCard';

export const MobileEpisodeSlideshow = ({
  compliance,
  episodes,
  isLoading,
  referrer,
}: {
  compliance: ComplianceType;
  episodes?: EpisodeCardType[];
  isLoading: boolean;
  referrer: Referrer;
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
      }}>
      {compliance === ComplianceTypes.CPE ? (
        <Box
          component="img"
          src={earnCpe}
          alt="Earn CPE"
          sx={[styles.pointerImage, styles.earnCompliancePointer]}
        />
      ) : (
        <Box
          component="img"
          src={earnCpd}
          alt="Earn CPD"
          sx={[styles.pointerImage, styles.earnCompliancePointer]}
        />
      )}
      <Box>
        <Slideshow>
          {episodes?.map((episode, index) => (
            <Box key={episode.episodeId}>
              <Box
                sx={{
                  width:
                    EpisodeCardDimensions[EpisodeCardVariants.MEDIUM].width,
                  margin: '0 auto',
                }}>
                <EpisodeCard
                  variant={EpisodeCardVariants.MEDIUM}
                  episode={episode}
                  referrer={{
                    ...referrer,
                    position: index + 1,
                  }}
                  isLoading={isLoading}
                />
              </Box>
            </Box>
          ))}
        </Slideshow>
      </Box>

      <Box
        component="img"
        src={bookmarkForLater}
        alt="Bookmark for later"
        sx={[styles.pointerImage, styles.bookmarkPointer]}
      />
    </Box>
  );
};

const styles = {
  pointerImage: {
    position: 'absolute',
    width: 64,
    height: 64,
    zIndex: 1,
  },
  bookmarkPointer: {
    bottom: 80,
    right: -16,
  },
  earnCompliancePointer: {
    top: 80,
    left: -16,
  },
};
